import { array, arrayOf, bool, element, eventListener, expression, func, instanceOf, number, object, oneOf, oneOfType, shape, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
const TabWithContentProperties = {
    activeTab: {
        type: string,
    },
    badge: {
        type: oneOfType([number, string]),
    },
    children: {
        type: oneOfType([element, arrayOf(element)]).notEnumerable(),
    },
    count: {
        type: oneOfType([number, string]),
    },
    data: {
        type: oneOf([array, object]),
    },
    enabled: {
        defaultValue: true,
        type: bool,
    },
    icon: {
        type: oneOfType([string, element]),
    },
    label: {
        type: expression,
    },
    name: {
        type: string,
    },
    onClick: {
        type: eventListener,
    },
    onContextMenu: {
        type: eventListener,
    },
    onDoubleClick: {
        type: eventListener,
    },
    tabContentRef: {
        type: oneOfType([
            func,
            shape({ current: instanceOf(Element) }),
        ]).notEnumerable(),
    },
    uppercase: {
        defaultValue: true,
        type: bool,
    },
    uuid: {
        type: string,
    },
    visible: {
        defaultValue: true,
        type: bool,
    },
};
export { TabWithContentProperties, };
//# sourceMappingURL=tab-with-content-types.js.map